import {UIDeviceController} from '../../shared/scripts/ui_html/UIDeviceController'
import {StorageWrapper} from '../../shared/scripts/StorageWrapper'
import {UIMRequestPushNotification} from './ui_popup/UIMRequestPushNotification'
import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables'
import {UIMGameModeSelectionPopup} from './ui_popup/UIMGameModeSelectionPopup'

export enum UIMGameMode {
    LANDSCAPE = 0,
    PORTRAIT = 1
}

export class UIMGameOrientationController {
    static readonly deprecatePortraitLandscapeToggleFromTimestamp = 1746037800000 // 1st may 2025
    constructor() {
        this.setPortraitModeForNewPlayers()
        this.disableLandscapeModeForNewPlayers()
        UIMRequestPushNotification.resetStorageTimeStamps()
        StorageWrapper.clearDeprecationStorage()
    }

    // eslint-disable-next-line class-methods-use-this
    private disableLandscapeModeForNewPlayers() {
        const firstSessionTimestamp = StorageWrapper.getFirstSessionTimestamp()
        if(firstSessionTimestamp == null) return

        const isNewPlayer = firstSessionTimestamp > UIMGameOrientationController.deprecatePortraitLandscapeToggleFromTimestamp
        if(!isNewPlayer) return

        const isIPadPlayer = UIDeviceController.isUserOnTabletApp()
        if(isIPadPlayer) return

        StorageWrapper.setPortraitGamePlayEnabled(true)
        if(!UIUtilsEjsVariables.hideLandscapeForNewPlayers) return
        document.getElementById('m-menu-game-mode')?.remove()
    }

    // eslint-disable-next-line class-methods-use-this
    private setPortraitModeForNewPlayers() {
        const shouldResetOrientation = StorageWrapper.shouldResetGameOrientation()
        if(shouldResetOrientation == false) return
        StorageWrapper.setPortraitGamePlayEnabled(true)
        StorageWrapper.setFirstSessionTimestamp(Date.now())
    }

    static showOrientationSelectionIfNotAlready(): boolean {
        const isUserOnTabletApp = UIDeviceController.isUserOnTabletApp()
        if(isUserOnTabletApp == false) return false

        const timeGameModeSelectionDisplayed = StorageWrapper.getTimestampUserSelectedGameMode()
        if(timeGameModeSelectionDisplayed != null && timeGameModeSelectionDisplayed > 0) return false
        new UIMGameModeSelectionPopup().show()
        return true
    }

    static resumeGameMode() {
        const timeGameModeSelectionDisplayed = StorageWrapper.getTimestampUserSelectedGameMode()
        if(timeGameModeSelectionDisplayed == null) return

        const gameModeButton = StorageWrapper.getGameModePlayerClicked()
        if(gameModeButton == null) return
        StorageWrapper.setGameModePlayerClicked(null)
        const button = document.getElementById(gameModeButton)
        button?.click()
    }
}
